import React, { useState } from "react";
import { createPortal } from "react-dom";

/******
 * https://github.com/facebook/react/issues/22847
 * This appears to be unrelated to react; firefox resets the iframe content after it receives the load event.
 */

export const IFrame = props => {
  const [iframeBody, setIframeBody] = useState(null);

  const { title = null, children = null, style = {} } = props;

  const handleLoad = event => {
    const iframe = event.target;
    if (iframe?.contentDocument) {
      setIframeBody(iframe.contentDocument.body);
    }
  };

  return (
    <iframe
      srcDoc={`<!DOCTYPE html>`}
      title={title}
      onLoad={handleLoad}
      style={style}
    >
      {iframeBody && createPortal(children, iframeBody)}
    </iframe>
  );
};
